import { createSlice } from '@reduxjs/toolkit';
import { ResetPasswordStateType } from 'src/types/resetPassword';

const initialState: ResetPasswordStateType = {
    loading: false,
    error: false,
    success: false,
};

export const resetPasswordSlice = createSlice({
    name: 'resetPassword',
    initialState,
    reducers: {
        resetPasswordFetch: (state, data) => {
            state.loading = true;
            state.success = false;
            state.error = false;
        },
        resetPasswordFetchSuccess: (state) => {
            state.loading = false;
            state.success = true;
            state.error = false;
        },
        resetPasswordFetchFailure: (state, action) => {
            state.loading = false;
            state.success = false;
            state.error = true;
        },
        clearResetPassword: () => {
            return initialState;
        },
    },
});

export const {
    resetPasswordFetch,
    resetPasswordFetchSuccess,
    resetPasswordFetchFailure,
    clearResetPassword,
} = resetPasswordSlice.actions;

export default resetPasswordSlice.reducer;
